


















































































































































































import Component from "vue-class-component";
import BaseComponent from "../../components/shared/BaseComponent.vue";
import TenantMembers from "@/components/app/settings/tenant/TenantMembers.vue";
import { UserDto } from "../../application/dtos/master/users/UserDto";
import EntityTableList from "@/components/shared/entities/EntityTableList.vue";
import { UserType } from "@/application/enums/master/users/UserType";
import services from "@/services";

@Component({ components: { TenantMembers, EntityTableList } })
export default class Users extends BaseComponent {
  private items: UserDto[] = [];
  mounted() {
    this.reload();
  }
  reload() {
    this.loading = true;
    services.users
      .adminGetAll()
      .then((response: UserDto[]) => {
        this.items = response;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  userType(user: UserDto) {
    return UserType[user.type];
  }
  impersonate(user: UserDto) {
    services.authentication.impersonate(user.id);
  }
  changePassword(user: UserDto) {
    const password = prompt(
      this.$t("settings.profile.changePassword") + " - " + user.email
    );
    if (!password || password.length < 8) {
      alert("Set a password with 8 characters minimum");
    } else if (user.type === 0) {
      alert("You cannot change password for admin user");
    } else {
      if (
        confirm("[ADMINISTRATOR] Update password for user " + user.email + "?")
      ) {
        services.users
          .adminUpdatePassword(user.id, password)
          .then(response => {
            alert("Updated");
          })
          .catch(error => {
            alert("Error: " + this.$t(error));
          });
      }
    }
  }
}
